<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Produit</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <hr class="bg-dark">
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de création</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon2">Date et temps de publication</span>
      </div>
      <input disabled type="text" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2">
      <input disabled type="text" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps d'expiration</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Code promotionnel</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Pourcentage</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de début</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et temps de fin</span>
      </div>
      <input disabled type="text" aria-label="First name" class="form-control">
      <input disabled type="text" aria-label="First name" class="form-control">
    </div>
  </form>
</template>

<script>
export default {
  name: "Read"
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/promotions/components/Read.vue